import { CupWaterIcon } from './CupWaterIcon';

/**
 * author: Google
 * id AC4AD054-775A-4D59-BF92-A57A6A952607
 * name cup-water
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cup-water.svg
 * tags
 * - Food / Drink 
 */
export const DrinkWaterIcon = CupWaterIcon;
export default DrinkWaterIcon